import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useMutation, QueryClient } from "@tanstack/react-query";
import ErrorMessage from "./errormessage";
import LoadingIndicator from "./loadingindicator";
import SaveAndContinue from "./saveandcontinue";
import { api } from "../shared";

const queryClient = new QueryClient();

export default function Form({
  form,
  setForm,
  submitUrl,
  nextUrl,
  style,
  enabled = true,
  showBack = true,
  submitLabel,
  redirect = true,
  handleSave,
  handleFinish = () => { },
  children
}) {
  const mutation = useMutation(
    (params) => {
      if (submitUrl !== undefined) return api(submitUrl, "POST", params);
    },
    {
      onSuccess: (data) => {
        setSaved(true);
        queryClient.invalidateQueries(["application"]);
        const { errors = {}, errors: { non_field_errors } = {} } = data || {};
        setForm({ ...form, errors: errors, non_field_errors });
        handleFinish();
      }
    }
  );
  const [saved, setSaved] = useState(false);
  const { data: { errors: { detail: errorDetail } = {} } = {} } = mutation;
  const hasAlreadySubmitted = errorDetail === "You do not have permission to perform this action.";
  const { data: { errors } = {}, isLoading, isSuccess, isError } = mutation;
  const success = isSuccess && !errors;
  useEffect(
    () =>
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      }),
    [errors]
  );
  if (hasAlreadySubmitted) return <Redirect to="/apply/submitted/" />;
  if (success && redirect) return <Redirect to={nextUrl} push={true} />;
  const alreadyRegistered =
    errors !== undefined &&
    Object.values(errors)
      .map((n) => n[0])
      .filter(
        (n) => n !== undefined && n.includes !== undefined && n.includes("already registered")
      ).length > 0;
  return (
    <div>
      <LoadingIndicator isLoading={isLoading} />
      {isError ? <ErrorMessage error={mutation.error} /> : null}
      {errors !== undefined &&
        form.non_field_errors === {} &&
        JSON.stringify(form.errors) !== JSON.stringify({ references: { non_field_errors: [] } }) ? (
        <ErrorMessage error={{ message: "Please correct errors" }} />
      ) : null}
      {form.non_field_errors !== undefined && form.non_field_errors !== {} ? (
        <ErrorMessage error={{ message: form.non_field_errors.join(" ") }} />
      ) : null}
      {form.errors !== null &&
        Object.keys(form.errors).length !== 0 &&
        JSON.stringify(form.errors) !== JSON.stringify({ references: { non_field_errors: [] } }) ? (
        <ErrorMessage error={{ message: "Please correct errors" }} />
      ) : null}
      {children}
      {alreadyRegistered && (
        <div style={{ color: "red", marginBottom: "2rem" }}>
          You may already have an account. Please <a href="/login?next=/apply">login</a> to
          continue.
        </div>
      )}
      {saved && <p>Saved</p>}
      <SaveAndContinue
        isLoading={isLoading}
        mutation={mutation}
        form={form}
        enabled={enabled}
        showBack={showBack}
        label={submitLabel}
        handleClick={handleSave}
      />
    </div>
  );
}
